import React, { useEffect, useState, useCallback } from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { BigNumber } from 'bignumber.js'
import { NavLink } from 'react-router-dom'
import { AuctionBake } from '../../constants/artwork'

// utils
import { DISHESDICT, SUPPORTTYPE } from '../../constants/bakery/nft'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { getSushiAddress } from '../../sushi/utils'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'

// components
import DishesPreviewModal from '../../components/restaurant/DishesPreviewModal'
import { ButtonConfirmed } from '../../components/Button'
import PlateCard from '../../components/restaurant/PlateCard'
import FoodsList from '../../components/restaurant/FoodsList'
import Value from '../../components/Value/OnlyValue'
import Loader from '../../components/Loader'
import Row, { AutoRow } from '../../components/Row'
import Loading from '../../components/Loader/Loading'
import Paginator from '../../components/Paginator'
import Search from '../Restaurant/components/Search'
import InsufficientModal from '../../components/nftInfo/modal/InsufficientModal'


// hooks
import useBlock from '../../hooks/bakery/useBlock'
import useRoi from '../../hooks/nft/useRoi'
import useAllowanceERC20  from '../../hooks/nft/useAllowanceERC20'
import useApproveERC20 from '../../hooks/nft/useApproveERC20'
import { useActiveWeb3React } from '../../hooks'
import useBuy  from '../../hooks/nft/useBuy'
import useYam from '../../hooks/bakery/useYam'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useInterval from '../../hooks/useInterval'
import { useWalletModalToggle } from '../../state/application/hooks'

import SortPets, { OptionProps } from '../Pet/components/SortPets'
import { getBakeryCombos, getBakeryCombosV2,getBakeryCombosV3 } from '../../service/nft'
import { useMarketLevel } from '../../state/market/hooks'

import useModal from '../../hooks/bakery/useModal'
import BiddingModal from '../Artworks/components/BiddingModal'
import useBid from '../../hooks/nft/useBidding'
import useUpdateBid from '../../hooks/nft/useUpdateBid'
import useAllowanceBid from '../../hooks/nft/useAllowanceBid'
import useApproveBid  from '../../hooks/nft/useApproveBid'
import useUserBids from '../../hooks/nft/useUserBids'
import useUserAsks from '../../hooks/nft/useUserAsks'
import useSellTokenTo from '../../hooks/nft/useSellTokenTo'
import useMaxBidPrice from '../../hooks/nft/useMaxBidPrice'
import { MARKETTYPE,MARKETTYPEV3,MARKETTYPEV1, NFTTYPE } from '../../constants/bakery/nft'

interface DishInfos {
  level: number
  stakingPowerMultiple: number
  bakeAmount: BigNumber
  stakingPowerAmount: BigNumber
  items: string[]
  tokenId: string
  staking?: boolean
  auctionPrice?: string
  maxBidPrice: string
  nftType: number
}

const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}  
`
const CardItem = styled.div`
  width: 276px;
  margin-bottom: 25px !important;
  margin-right: 12px;
  margin-left: 12px;
`
const CardTitle = styled.div`
  padding: 16px 16px 8px;
`
const AttachWrapper = styled.div`
  margin-top: 16px;
`
const AttachRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  &:firt-child {
    margin-top: 32px;
  }
`
const ValueItem = styled.div`
  display: flex;
  align-items: center;
`
const ButtonGroupsWrapper = styled.div`
  padding: 22px 0;
`
const ButtonGroup = styled.div`
  display: flex;
  padding: 0 16px;
  button:first-child {
    padding: 0 12px;
  }
  button:last-child {
    flex: 1;
  }
  button:nth-child(2) {
    margin-left: 8px;
  }
`
const BakeText = styled.div`
  margin-left: 5px;
`

const NoCombo = styled.div`
  font-family: Baloo Da;
  margin-top: 97px;
`
const PageHead = styled.div`
  display: flex;
  width: 1204px;
  margin: 32px 0 28px;
  justify-content: space-between;
  box-sizing: border-box;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: calc(100% - 40px);
    justify-content: center;
  `}
`
const MyCombos = styled(NavLink)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 210px;
  background: ${({ theme }) => theme.primary1};
  border-radius: 10px;
  color: ${({ theme }) => theme.bsText1};
  font-family: Baloo Da;
  height: 40px;
  text-decoration: none;
  margin-right: 16px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-right: 0;
    margin-bottom: 16px;
  `}
`
const MiniPets = styled.img`
  width: 28px;
  height: auto;
`
const BalanceBtn = styled.div`
  /* padding: 0 24px; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > button {
    width: 113px;
  }
`
const MyEggsRow = styled(Row)`
  align-items: center;
  flex-shrink: 0;
  width: auto;
  margin-bottom: 10px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-direction: column;
    align-items: center;
    &>div{
      margin-bottom: 20px;
    }
    &>a{
      margin-bottom: 20px;
    }
  `}
`
const ComBtn = styled(ButtonConfirmed)<{bg?:string}>`
  background: ${({ bg,theme }) => bg ? bg : theme.bsBg4};
  color: ${({ theme }) => theme.bsText8};
`

const DishBox = (
  {
    marketType,
    dish,
    buySuccess,
    bakeBalance,
    allowanceBuy,
    currentBlock,
    account
  }: {
    marketType: string,
    dish: any,
    buySuccess: Function,
    bakeBalance: number,
    allowanceBuy: BigNumber,
    currentBlock: number,
    account: any
  }
) => {

  const roi = useRoi(currentBlock, dish.stakingPowerMultiple, NFTTYPE.COMBO_V3)
  const [requestedApprovalBuy, setRequestedApprovalBuy] = useState(false)
  const toggleWalletModal = useWalletModalToggle()
  const level = useMarketLevel()
  const { chainId } = useActiveWeb3React()
  const symbol = SUPPORTTYPE.BAKE

  // 获取我的竞价
  const [requestedBid, setRequestedBid] = useState(false)
  const [isGetIds, setIsGetIds] = useState(false)
  const getBids = useUserBids(marketType)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const [isExchange, setIsChange] = useState<boolean>(true)
  const [isShowFlag, setIsShowFlag] = useState<boolean>(false)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)

      bids.forEach((d: any) => {
        getBakeryCombosV2(chainId as number, {ids: d[0]}, (err: any, data: any) => {
          setIsShowFlag(true)
          if (err) return
          if (data.code !== 0) return
          const item = data.data.list[0]
          const isExchange = +item.price > 0
          if (item.id === dish.tokenId) {
            setIsChange(isExchange)
          }
        })
      })
    }
    setIsGetIds(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBids])

  // 获取我的挂单
  const getAsks = useUserAsks(marketType)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])

  useEffect(() => {
    if (account) {
      getAskIds()
      getIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, account, requestedBid, dish])

  const [openInsufficientModal] = useModal(
    <InsufficientModal />
  )

  // BUY
  const [requestedBuy, setRequestedBuy] = useState(false)
  const { onBuy } = useBuy(dish.tokenId, marketType, symbol)
  const buyCombo = useCallback(async () => {
    if(level === 'v3'){
      try {
        if (dish.price !== undefined && new BigNumber(bakeBalance).lt(!dish.auctionPrice ? dish.price : dish.auctionPrice)) {
          openInsufficientModal()
          return
        }
        setRequestedBuy(true)
        const price = new BigNumber(+dish.price).times(new BigNumber(10).pow(18)).toString()
        const txHash = await onBuy(price)
        if (!txHash) {
          setRequestedBuy(false)
        } else {
          buySuccess({...dish})
        }
      } catch (e) {
        console.log(e)
      }
    }
  }, [dish, onBuy, buySuccess, bakeBalance, openInsufficientModal])

  const onApproveBuy = useApproveERC20(marketType)
  const handleApproveBuy = useCallback(async () => {
    if(level === 'v3'){
      try {
        setRequestedApprovalBuy(true)
        const txHash = await onApproveBuy()
        if (!txHash) {
          setRequestedApprovalBuy(false)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }, [onApproveBuy, setRequestedApprovalBuy])

  //授权竞价
  const [requestedApprovalBid, setRequestedApprovalBid] = useState(false)
  const onApproveBid = useApproveBid(marketType)
  const handleApproveBid = useCallback(async (event) => {
    if(level === 'v3'){
      try {
        setRequestedApprovalBid(true)
        const txHash = await onApproveBid()
        if (!txHash) {
          setRequestedApprovalBid(false)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }, [onApproveBid, setRequestedApprovalBid])

  // 竞价
  const handBid = () => {
    if(level === 'v3'){
      if (ids.includes(dish.tokenId)) {
        onUpdateBid()
        return
      }
      if (aksIds.includes(dish.tokenId)) {
        onLookBidding()
      } else {
        onBidding()
      }
    }
  }

  // 将token卖给指定地址
  const {onSellBid} = useSellTokenTo(dish.tokenId, marketType, SUPPORTTYPE.BAKE) 
  const onSellTokenTo = useCallback(async (address: string, price?: any) => {
    try {
      const txHash = await onSellBid(address, price)
      console.log('------->txHash', txHash)
    } catch (e) {
      console.log(e)
    }
  }, [onSellBid])

  // Bidding
  const allowanceBid = useAllowanceBid(marketType)
  const {onBid} = useBid(dish.tokenId, marketType) 
  const {onMaxBidPrice} = useMaxBidPrice(dish.tokenId, dish.nftType)
  const handleBid = useCallback(async (amount: string) => {
    try {
      const txHash = await onBid(amount)
      txHash && dish.auctionPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(18)).toString())
      if (txHash) {
        setRequestedBid(true)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onBid, dish, onMaxBidPrice])
  const [bidding] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={handleBid}
      isBidding={true}
      tokenId={dish.tokenId}
      type={marketType}
      auctionPrice={dish.auctionPrice}
    />,
  )
  const onBidding = useCallback(async () => {
    bidding()
  }, [bidding])

  // 查看竞价列表
  const [lookBidding] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={onBid}
      isBidding={false}
      tokenId={dish.tokenId}
      type={marketType}
      auctionPrice={dish.auctionPrice}
    />,
  )
  const onLookBidding = useCallback(async () => {
    lookBidding()
  }, [lookBidding])
  
  // 更新竞价
  const {onUpdate} = useUpdateBid(dish.tokenId, marketType, dish.auctionPrice ? onMaxBidPrice : '')
  const [updateBid] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={onUpdate}
      isBidding={true}
      tokenId={dish.tokenId}
      type={marketType}
      auctionPrice={dish.auctionPrice}
    />,
  )
  const onUpdateBid = useCallback(async () => {
    updateBid()
  }, [updateBid])

  return (
    <CardItem>
      <PlateCard
        dish={dish}
        ids={ids}
        iconUrl={(process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/' + dish.dishIcon}
        level={dish.level + 1}
        price={dish.exchange ? (!dish.auctionPrice ? dish.price : dish.auctionPrice) : undefined}
        headerHeight={170}
        isExchange={isExchange}
        isShowFlag={isShowFlag}
        bidFlag={level !== 'v1' && ids.includes(dish.tokenId) && isGetIds}
        auctionPrice={dish.auctionPrice}
        levelType={level}
        bg={level === 'v3' ? '' : '#DEDEDE' }
      >
        <CardTitle>
          <Text fontSize={22}>{DISHESDICT[dish.level]}</Text>
        </CardTitle>
        <FoodsList items={dish.items} bg={level === 'v3' ? '' : '#C4C4C4' }></FoodsList>
        <AttachWrapper>
          <AttachRow>
            <Text fontSize={14}>Decompose to get:</Text>
            <ValueItem>
              <Value decimals={0} value={new BigNumber(dish.bakeAmount).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)} />
              <BakeText>BAKE</BakeText>
            </ValueItem>
          </AttachRow>
          <AttachRow>
            <Text fontSize={14}>Staking Power:</Text>
            <Text>
              <Value decimals={0} value={new BigNumber(dish.stakingPowerAmount).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)} />
            </Text>
          </AttachRow>
          <AttachRow>
            <Text fontSize={14}>ROI:</Text>
            <Text>
              <Value
                decimals={0}
                value={
                  roi && !roi.isNaN() && roi.gt(0)
                    ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%'
                    : '-'
                }
              />
            </Text>
          </AttachRow>
          <AttachRow style={{margin: '15px 0 -25px'}}>
            <Text fontSize={14}>Price(BAKE):</Text>
            <Text fontSize={22}>
              <Value decimals={0} value={dish.price ? new BigNumber(!dish.auctionPrice ? dish.price : dish.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) : '-'} />
            </Text>
          </AttachRow>
        </AttachWrapper>
        <ButtonGroupsWrapper>
        <ButtonGroup style={{marginTop: 8}}>
            {
              account ? 
                level === 'v1' ? (allowanceBuy.toNumber() ? (
                  <ComBtn
                    onClick={buyCombo}
                    disabled={requestedBuy}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedBuy}
                    bg={'#C4C4C4' }
                  >
                    {
                      requestedBuy ? (
                        <AutoRow gap="6px" justify="center">
                          Pending <Loader stroke="white" />
                        </AutoRow>
                      ) : (
                        'Buy this Combo'
                      )
                    }
                  </ComBtn>
                ) : (
                  <ComBtn
                    onClick={handleApproveBuy}
                    disabled={requestedApprovalBuy}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedApprovalBuy}
                    bg={'#C4C4C4' }
                  >
                    {requestedApprovalBuy ? (
                      <AutoRow gap="6px" justify="center">
                        Approving <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Approve NFT Marketplace'
                    )}
                  </ComBtn>
                )) : (
                  allowanceBuy?.toNumber() && allowanceBid?.toNumber() ? (
                    !dish.auctionPrice ? (
                      <BalanceBtn>
                        <ComBtn
                          onClick={handBid}
                          fontSize={14}
                          height={40}
                          style={{
                            marginRight: 16,
                          }}
                          bg={level === 'v3' ? '' : '#C4C4C4' }
                        >
                          Bidding
                        </ComBtn>
                        <ComBtn
                          onClick={buyCombo}
                          disabled={requestedBuy || ids.includes(dish.tokenId)}
                          fontSize={14}
                          height={40}
                          altDisabledStyle={requestedBuy || ids.includes(dish.tokenId)}
                          bg={level === 'v3' ? '' : '#C4C4C4' }
                        >
                          {
                            requestedBuy ? (
                              <AutoRow gap="6px" justify="center">
                                Pending <Loader stroke="white" />
                              </AutoRow>
                            ) : (
                              'Buy'
                            )
                          }
                        </ComBtn>
                      </BalanceBtn>
                    ): (
                      <ComBtn
                        onClick={handBid}
                        width={240}
                        height={40}
                        bg={level === 'v3' ? '' : '#C4C4C4' }
                      >
                        Bidding
                      </ComBtn>
                    )
                  ) : (
                    <ComBtn
                      onClick={handleApproveBid}
                      disabled={requestedApprovalBid}
                      fontSize={14}
                      height={40}
                      altDisabledStyle={requestedApprovalBid}
                      bg={level === 'v3' ? '' : '#C4C4C4' }
                    >
                      {
                        requestedApprovalBid ? (
                          <AutoRow gap="6px" justify="center">
                            Approving <Loader stroke="white" />
                          </AutoRow>
                        ) : 'Approve NFT Marketplace'
                      }
                    </ComBtn>
                  )
                )
              : (
                <ComBtn
                  onClick={toggleWalletModal}
                  fontSize={14}
                  height={40}>
                  Connect Wallet
                </ComBtn>
              )
            }
          </ButtonGroup>
        </ButtonGroupsWrapper>
      </PlateCard>
    </CardItem>
  )
}

const options: OptionProps[] = [{
  sortName: 'price',
  sortBy: 'asc',
  key: 1,
  name: 'Price',
}, {
  sortName: 'price',
  sortBy: 'desc',
  key: 2,
  name: 'Price',
}, {
  sortName: 'stakingPowerAmount',
  sortBy: 'asc',
  key: 3,
  name: 'Power',
}, {
  sortName: 'stakingPowerAmount',
  sortBy: 'desc',
  key: 4,
  name: 'Power',
}]

const DishesList = (
  {
    marketType,
    dishes,
    buySuccess,
    bakeBalance,
    allowanceBuy,
    currentBlock,
    account
  }: {
    marketType: string,
    dishes:DishInfos[],
    buySuccess: Function,
    bakeBalance: number,
    allowanceBuy: BigNumber,
    currentBlock: number,
    account: any
  }
) => {
  const Row = dishes.map((d, index) => {
    return index < 9 ? <DishBox
      marketType={marketType}
      key={d.tokenId}
      dish={d}
      buySuccess={buySuccess}
      bakeBalance={bakeBalance}
      allowanceBuy={allowanceBuy}
      currentBlock={currentBlock}
      account={account}
    /> : ''
  })
return <ListWrapper>{ Row }</ListWrapper>
}

export default function Exchange() {
  let marketType = MARKETTYPEV3.DISHV3
  const currentBlock = useBlock()
  const { account, chainId } = useActiveWeb3React()
  const LIMIT = 12
  const emptyAsks: any[] = []
  const level = useMarketLevel()

  const [page, setPage] = useState(1)
  useEffect(() => {
    setPage(1)
  }, [account, chainId, level])

  const [curValue, setCurValue] = useState('')
  const [searchValue, setSearchValue] = useState('')

  const inputChange = useCallback((e: any) => {
    setCurValue(e.target.value)
  }, [])

  const searchHandle = (value: string) => {
    setSearchValue(value)
    setPage(1)
    if (value === searchValue && page === 1) {
      fetchAsksSort(page, curSelect, searchValue, true)
    }
  }

  const [asks, setAsks] = useState(emptyAsks)
  const [loadingFlag, setLoadingFlag] = useState(false)

  const [curSelect, setCurSelect] = useState(options[0])

  useEffect(() => {
    fetchAsksSort(page, curSelect, searchValue, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, chainId, curSelect, level, searchValue])

  useInterval(() => {
    fetchAsksSort(page, curSelect, searchValue)
  }, account ? 10000 : null)

  const pageHandle = useCallback((value) => {
    setPage(value)
  }, [])

  // success modal
  const [modalOpen, setModalOpen] = useState(false)
  const [purchasedDish, setPurchasedDish] = useState(null)
  const handleDismiss = useCallback(() => {
    setModalOpen(false)
    setPurchasedDish(null)
  }, [setModalOpen])
  const buySuccess = useCallback((dish) => {
    setPurchasedDish(dish)
    setModalOpen(true)
  }, [setModalOpen, setPurchasedDish])

  // bake balance
  const [bakeBalance, setBakeBalance] = useState(0)
  const yam = useYam()
  const bakeryBalance = useTokenBalance(getSushiAddress(yam))
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance)
    setBakeBalance(balance)
  }, [yam, bakeryBalance])

  // Allowance BAKE buy Combo
  const allowanceBuy = useAllowanceERC20(marketType)

  const updateData = useCallback((d) => {
    setCurSelect(d)
    setPage(1)
  }, [])

  // count
  const [pageCount, setPageCount] = useState(0)
  const fetchAsksSort = async (page: number, rank: OptionProps, searchValue: string, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      offset: (page - 1) * LIMIT,
      limit: LIMIT + 1,
      sortName: rank.sortName,
      sortBy: rank.sortBy,
      onSale: 1,
      keyword: searchValue.trim()
    }
    if (level === 'v1') {
      marketType = MARKETTYPEV1.DISHV1
      getBakeryCombos(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        setPageCount(Math.ceil(data.data.count / LIMIT))
        const eggs = dataAry.map((d: any) => {
          return {
            ...d,
            ...(d.price ? {price: d.price.toString()} : {}),
            ...(d.bakeAmount ? {bakeAmount: d.bakeAmount.toString()} : {}),
            exchange: true,
            tokenId: d.id,
            dishIcon:
              d.items
                .map((s: string | number) => {
                  const valBinary = new BigNumber(s)
                    .div(100000)
                    .integerValue(BigNumber.ROUND_FLOOR)
                    .toString(2)
                  return valBinary.length < 2 ? '0' + valBinary : valBinary
                })
                .join('') + '.svg',
            nftType: 10,
            auctionPrice: ((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? d.auctionPrice : ''),
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
          }
        })
        setAsks(eggs)
        setLoadingFlag(false)
      })
    } else if (level === 'v2'){
      marketType = MARKETTYPE.DISH
      getBakeryCombosV2(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        setPageCount(Math.ceil(data.data.count / LIMIT))
        const eggs = dataAry.map((d: any) => {
          return {
            ...d,
            ...(d.price ? {price: d.price.toString()} : {}),
            ...(d.bakeAmount ? {bakeAmount: d.bakeAmount.toString()} : {}),
            exchange: true,
            tokenId: d.id,
            dishIcon:
              d.items
                .map((s: string | number) => {
                  const valBinary = new BigNumber(s)
                    .div(100000)
                    .integerValue(BigNumber.ROUND_FLOOR)
                    .toString(2)
                  return valBinary.length < 2 ? '0' + valBinary : valBinary
                })
                .join('') + '.svg',
            nftType: 10,
            auctionPrice: ((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? d.auctionPrice : ''),
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
          }
        })
        setAsks(eggs)
        setLoadingFlag(false)
      })
    }else{
      marketType = MARKETTYPEV3.DISHV3
      getBakeryCombosV3(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        setPageCount(Math.ceil(data.data.count / LIMIT))
        const eggs = dataAry.map((d: any) => {
          return {
            ...d,
            ...(d.price ? {price: d.price.toString()} : {}),
            ...(d.bakeAmount ? {bakeAmount: d.bakeAmount.toString()} : {}),
            exchange: true,
            tokenId: d.id,
            dishIcon:
              d.items
                .map((s: string | number) => {
                  const valBinary = new BigNumber(s)
                    .div(100000)
                    .integerValue(BigNumber.ROUND_FLOOR)
                    .toString(2)
                  return valBinary.length < 2 ? '0' + valBinary : valBinary
                })
                .join('') + '.svg',
            nftType: 10,
            auctionPrice: ((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? d.auctionPrice : ''),
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
          }
        })
        setAsks(eggs)
        setLoadingFlag(false)
      })
    }
  }

  return (
    <>
      <Loading open={loadingFlag} />
      <DishesPreviewModal isOpen={modalOpen} onDismiss={handleDismiss} dish={purchasedDish} />
      <PageHead>
        <MyCombos to='/my-combos'>
          <MiniPets src="/images/nft/combos.svg" alt="" />
          <Text marginLeft={1} marginRight={12}>My Combos</Text>
        </MyCombos>
        <MyEggsRow style={{justifyContent: 'flex-end'}}>
          <Search value={curValue} inputChange={inputChange} searchHandle={searchHandle}></Search>
          <SortPets
            margin="0 0 0 15"
            curSelect={curSelect}
            options={options}
            updateData={updateData}
          ></SortPets>
        </MyEggsRow>
      </PageHead>
      {
        asks.length ? (
          <>
            <DishesList marketType={marketType} dishes={asks} buySuccess={buySuccess} bakeBalance={bakeBalance} allowanceBuy={allowanceBuy} currentBlock={currentBlock} account={account}></DishesList>
            {
              pageCount > 1 && (
                <Paginator pageCount={pageCount} curPage={page} page={pageHandle}></Paginator>
              )
            }
          </>
        ) : (
          <NoCombo>
            <Text fontSize={24}>There is no NFT on sale</Text>
          </NoCombo>
        )
      }
    </>
  )
}